import type { TomDoSelo } from './preditiva';

/**
 * O selo da preditiva (p.24): preenchido, com o ponto na cor 500 e a palavra
 * escrita, nunca só a cor. É a situação da falha, do modelo, da previsão ou
 * da proposta — nunca um dos seis status da máquina: a previsão aberta é
 * âmbar de atenção, e não o laranja de "Em manutenção" nem o vermelho de
 * "Parada". O mesmo na mesa e no celular.
 */
const CLASSES: Readonly<Record<TomDoSelo, { readonly fundo: string; readonly ponto: string }>> = {
  sucesso: { fundo: 'bg-sucesso-fundo text-sucesso-texto', ponto: 'bg-sucesso' },
  atencao: { fundo: 'bg-atencao-fundo text-atencao-texto', ponto: 'bg-atencao' },
  erro: { fundo: 'bg-erro-fundo text-erro-texto', ponto: 'bg-erro' },
  informacao: { fundo: 'bg-informacao-fundo text-informacao-texto', ponto: 'bg-informacao' },
  neutro: { fundo: 'bg-nao-alocado-fundo text-nao-alocado-texto', ponto: 'bg-nao-alocado' },
};

export function SeloDaPreditiva({ rotulo, tom }: { readonly rotulo: string; readonly tom: TomDoSelo }) {
  const c = CLASSES[tom];
  return (
    <span className={`inline-flex min-h-[var(--selo-altura)] max-w-full shrink-0 items-center gap-1.5 rounded-pill px-2.5 py-1 ${c.fundo}`}>
      <span aria-hidden="true" className={`size-[var(--selo-ponto)] shrink-0 rounded-pill ${c.ponto}`} />
      <span className="txt-selo leading-tight whitespace-nowrap">{rotulo}</span>
    </span>
  );
}
